import { useEffect } from 'react';
import type { IScreensLogging } from 'shared/src/api/types';
import { bridge } from 'shared/src/utils';
import type { LogAnalyticsEventParams } from 'shared/src/utils/bridge/logAnalyticsEvent/types';

type UseLogViewEventProps = {
  logging?: IScreensLogging;
  screenName?: string;
};

export const useLogViewEvent = ({
  logging,
  screenName,
}: UseLogViewEventProps) => {
  useEffect(() => {
    if (!logging || !screenName) {
      return;
    }
    logCheckExp1601TargetEvent(screenName);
    bridge.logAnalyticsEvent({
      name: `VIEW_${screenName}`,
      analytics: logging.analytics as LogAnalyticsEventParams['analytics'],
      ably_only_log: logging.ably_only_log,
    });
  }, [logging, screenName]);
};

const logCheckExp1601TargetEvent = (screenName: string) => {
  if (
    screenName === 'CATEGORY_DEPARTMENT' ||
    screenName === 'SUB_CATEGORY_DEPARTMENT'
  ) {
    bridge.logAnalyticsEvent({
      name: 'CHECK_EXP_1601_TARGET',
      analytics: {
        SCREEN: screenName,
      },
    });
  }
};
